import * as d3 from "d3";
import Tooltip from "./Tooltip.js";
import * as _ from "lodash";

const Chart = {
  create(options) {
    var instance = Object.create(this);

    Object.keys(options)
      .forEach(function(key) {
        instance[key] = options[key];
      });

    return instance;
  },
  tooltip: Tooltip,
  data: [],
  margin: {
    "top": 50,
    "right": 25,
    "bottom": 5,
    "left": 92
  },
  el: "#barchart",
  initialSort: 'percent_underrep',
  valueType: "percent",
  colorHash: {
  },
  fixData() {
    // convert all the data to numeric
    // get keys except for company
    const keys = this.keys;

    (this.data).forEach( (company) => {
      // for each company, turn each of its values numeric
      keys.forEach( (key) => {
        company[key] = +company[key];
      });
      // this is where we'll put the totals
      company.meta = {};
     // calc total people
     let total = keys.reduce( (sum, key) => {
        return sum + company[key];  
      }, 0); 

      let total_females = keys.reduce( (sum, key) => {

        if(key.indexOf("female") > 0){
          return sum + company[key];
        }
         return sum;
      }, 0);
      // add up some columns
        
      let underrep = company['American_Indian_Alaskan_Native_female'] + company['Black_or_African_American_female'] +
        company['Latino_female'] +
        company['Native_Hawaiian_or_Pacific_Islander_female'] +
        company['Two_or_more_races_female'];
      
      // attach the data to the meta object
      company.meta.total = total;
      company.meta.total_females = total_females;
      company.meta.percent_female = (total_females/total);
      company.meta.percent_underrep = (underrep/total);
      company.meta.percent_male = (company['Total_male'] / total);
      company.meta.percent_asian_female = (company['Asian_female']/total);
      company.meta.percent_white_female = (company['White_female']/total);
      company.meta.percent_black_female = (company['Black_or_African_American_female']/total);
      company.meta.percent_native_female = (company['American_Indian_Alaskan_Native_female']/total);
      company.meta.percent_latino_female = (company['Latino_female']/total);
      company.meta.percent_pac_female = (company['Native_Hawaiian_or_Pacific_Islander_female']/total);
      company.meta.two_female = (company['Two_or_more_races_female']/total);

    });
  },

  sort(){
    // sort descending by initial sort
    this.data.sort((a, b) => {
       return (a.meta[this.initialSort] - b.meta[this.initialSort]);
    });
  },

  // takes a category and sorts by that
  sortLabels(){
    let category = this.initialSort;

    // the button categories
    let i = this.labelKeys.indexOf(category)
    // remove the category from the key
    this.labelKeys.splice(i, 1);
    // add it back on the end
    this.labelKeys.unshift(category);

    // re-reduce the dataset so that we only have the percent values I've stored in meta
    this.labelSet = this.data.map( each =>{
      // picks only certain props
      const res  =  _.pick(each.meta, 'percent_asian_female', 'percent_underrep', 'percent_white_female', 'percent_male');

      res.company = each.company;
      return res;
    });

    // sort the set of label data based on category
    this.labelSet = this.labelSet.sort( (a,b) => {
      return (a[category] - b[category]);
    }); 

  },
  calculateParamaters() {
    this.elWidth = document.querySelector(this.el).clientWidth;
    this.elHeight = this.elWidth * 0.75;

    if(this.elHeight < 600){
      this.elHeight = 600;
    }
    this.width = this.elWidth - this.margin.left - this.margin.right;
    this.height = this.elHeight - this.margin.top - this.margin.bottom;

    // calculate keys from colorHash
    this.keys = Object.keys(this.colorHash);
    this.setTransition();
    console.log(this.width, this.height);
  },
  createScales() {
    this.yScale = d3.scaleBand()
      .rangeRound([this.height, 0])
      .padding(0.1)
      .align(0.1)
      .domain(this.data.map((d) => {
        return d.company;
      }));

    this.xScale = d3.scaleLinear()
      .rangeRound([0, this.width])

  },
  createColorScale() {
    let c = this.colorHash;
    // range is a list of race keys 
    let range = []
    this.keys.forEach( d => range.push(c[d]));

    this.colorScale = d3.scaleOrdinal()
      .range(range)
      .domain(this.keys);
  },
  createStack() {
    this.stack = d3.stack()
      .offset(d3.stackOffsetExpand);
  },
  createPlot() {
    this.svg = d3.select(this.el).append("svg")
      .attr("width", this.elWidth)
      .attr("height", this.elHeight);

    this.plot = this.svg.append("g").attr("transform", `translate(${this.margin.left}, ${this.margin.top})`);

  },
  updatePlot(){
    this.svg = this.svg
      .attr("width", this.elWidth)
      .attr("height", this.elHeight);
  
    this.plot = this.plot
      .attr("transform", `translate(${this.margin.left}, ${this.margin.top})`);
  
  },

  drawAxes() {
    this.xAxis = d3.axisTop(this.xScale)
      .ticks(5, "%");

    this.yAxis = d3.axisLeft(this.yScale);

    // add axes
    this.plot.append("g")
      .attr("class", "axis axis--x")
      .call(this.xAxis);

    let yAxisGroup = this.plot.append("g")
      .attr("class", "axis axis--y")
      .call(this.yAxis);

   // add ids to ticks
    yAxisGroup.selectAll(".tick")
      .select("text")
      .attr("id", d =>  {
        // remove all spaces from name
        let idstring = d.replace(/[\s\.23]/g, '');
        return idstring;
      });
  },

  updateAxes() {

    const t = d3.transition()
      .duration((this.durationVal - 250));

    this.xAxis = d3.axisTop(this.xScale)
      .ticks(5, "%");

    this.yAxis = d3.axisLeft(this.yScale);

    this.plot.select(".axis--x")
        .call(this.xAxis)
    
    this.plot.select(".axis--y")
      .transition(t)
        .call(this.yAxis)
      .selectAll("g")
  },
  setTransition(){
    // this is to be shared across things
    this.durationVal = 1000;
  },
  updateBars(transition){
    const that = this;
    console.log("update ran");

    // new data
    let stack = (this.stack.keys(this.keys))(this.data)

    this.serie = this.plot.selectAll(".serie") 
      .data(stack)
      .attr("data-id", d => d.key)
      .attr("fill", d => {
        return that.colorScale(d.key)
      });

    // update the bars
    this.bars = this.serie.selectAll("rect")
      .data(d => { return d });

    // this affects new bars and old bars
    this.bars
     // .enter().append("rect")
      .attr("class", d => d.data.company)
      .attr("height", that.yScale.bandwidth())
      .transition() 
      .duration(this.durationVal)
        .attr("x", d => that.xScale(d[0]))
        .attr("width", d => {
          return that.xScale(d[1]) - that.xScale(d[0]);
        })
        .attr("y", d => {
          return that.yScale(d.data.company)
        });
       
      },
  drawBars() {
    const that = this;
    
    // make a group for each measure
    this.serie = this.plot.selectAll(".serie")
      .data((this.stack.keys(this.keys))(this.data))
      .enter().append("g")
      .attr("class", "serie")
      .attr("data-id", d => d.key)
      .attr("fill", d => {
        return that.colorScale(d.key);
      });

   this.bars = this.serie.selectAll("rect")
      .data( d => {
        return d;
      })
      .attr("class", d => {
        return d.data.company;
      })
      .enter().append("rect")
      .attr("x", (d) => {
        return that.xScale(d[0]);
      }) // d[0] is the start point
      .attr("y", (d) => {
        return that.yScale(d.data.company);
      })
      // subtract the start point from the end point to get the width
      .attr("width", (d) => {
        return that.xScale(d[1]) - that.xScale(d[0]);
      })
      .attr("height", that.yScale.bandwidth());

  },
  updateLabels(){
    const that = this;
    const t = d3.transition()
      .duration(this.durationVal - 250)
      .delay(100);
    
    console.log("updatelabels ran");

    let newStack = (this.stack.keys(this.labelKeys))(this.labelSet);


    // replace the label series with new data
    this.labelSerie = this.plot.selectAll(".labelSerie")
      .data(newStack);

    // replace the labels with new labels 
    this.labels = this.labelSerie.selectAll("text")
      // add the key (measure) to the items
      .data( d => {
        d.forEach(each =>{
          each.key = d.key;

          return each;
        });
        return d;
      })
      .transition(t)
        .attr("x", d => {
          // calculate the midpoint of the serie
          let distance = (that.xScale(d[1]) + that.xScale(d[0])) / 2;
          return distance;
        })
         .attr("y", d => {
            return this.yScale(d.data.company) + (that.yScale.bandwidth() / 2);
         })
        .attr("fill", function(d) {
          if (d.key == "percent_underrep") {
            return "#222222";
          }
          return "white";

        })
        .style("opacity", (d,i) => {

        let value = (d.data)[d.key]
        // only show the first(last) one for now
          if(i < (this.data.length - 1)){
            return 0;
        }

        // don't show if it's too small
        if((this.elWidth < 500) && (value < 0.06)){
          return 0;
        }
          
        })
        .text( (d,i) => {
          let formatter = d3.format(".0%");
          let value = (d.data)[d.key];
          if (d.key == "percent_male") {
            return;
          }

          return `${formatter(value)}`;
        });
  },
  drawLabels() {
    const that = this;
    
    // make a new scale for percentage values
    this.labelXScale = d3.scaleLinear()
      .rangeRound([0, this.width])
      .domain([0, 1]);
    
    // reduce the dataset so that we only have the percent values I've stored in meta
    this.labelSet = this.data.map( each =>{
      const res  =  _.pick(each.meta, 'percent_asian_female', 'percent_underrep', 'percent_white_female', 'percent_male');

      res.company = each.company;
      return res;

    });

    // hard code the keys cause it's easier that way
    this.labelKeys = ['percent_underrep', 'percent_asian_female', 'percent_white_female', 'percent_male'];

    let stack = ((this.stack.keys(this.labelKeys))(this.labelSet)); 
    
    // add the groups
    this.labelSerie = this.plot.selectAll(".labelSerie")
      .data(stack)
      .enter()
      .append("g")
      .attr("class", "labelSerie");
      
    // add the texts
    this.labels = this.labelSerie.selectAll("text")
      .data( d => {
        d.forEach( each => {
          each.key = d.key;
          return each;
        });

        return d;    
      })
      .enter()
      .append("text")
      .attr("class", "labels")
      .attr("x", d => {
        // calculate the midpoint of the serie
        let distance = (that.xScale(d[1]) + that.xScale(d[0])) / 2;
        return distance;
      })
       .attr("y", d => {
          return this.yScale(d.data.company) + (that.yScale.bandwidth() / 2);
       })
      .attr("dy", "+0.3em")
      .attr("fill", function(d) {

        if (d.key == "percent_underrep") {
          return "#222222";
        }
        return "white";
      })
      .attr("text-anchor", "middle")
      .style("opacity", (d,i) => {
        let value = (d.data)[d.key]
        // only show the first(last) one for now
          if(i < (this.data.length - 1)){
            return 0;
        }

        // don't show if it's too small
        if((this.elWidth < 500) && (value < 0.06)){
          return 0;
        }
      })
      .text( (d,i) => {
        let formatter = d3.format(".0%");
        let value = (d.data)[d.key];
        if (d.key == "percent_male") {
          //return "#222222";
          return;
        }
        //if 
        return `${formatter(value)}`;
      });
  }, 
  // listening to click events
  sortOn(category) {
    console.log(`sorting on ${category}`);

    // hash for how to group the categories:
    const categoryHash = {
      percent_underrep: ['American_Indian_Alaskan_Native_female', 'Black_or_African_American_female', 'Latino_female', 'Native_Hawaiian_or_Pacific_Islander_female', 'Two_or_more_races_female'],
      percent_asian_female: ['Asian_female'],
      percent_white_female: ['White_female'],
      //percent_male: ['Total_male']
    }

    // re-organize the keys sort
    categoryHash[category].forEach( each => {
      // get index of the category's item(s)
      let i = (this.keys).indexOf(each);
    // remove category from they keys
     (this.keys).splice(i, 1);
    // add the category back in on the end
     (this.keys).unshift(each);
    });

    // re-organize the label keys too
    // don't use the hash because they label keys are identical to
    // the button categories
    let i = this.labelKeys.indexOf(category)
    this.labelKeys.splice(i, 1);
    this.labelKeys.unshift(category);

    // reset the sort
    this.initialSort = category;
    this.sort();
    this.sortLabels();

    // redo all your all your basic crap
    this.createScales(); // resets color
    this.updateAxes(); // concerned about y-axis here

    // wipe out the stacks, start again 
    //this.serie = this.plot.selectAll(".serie").remove();
    //this.drawBars();

    //update the bars
    this.updateBars();
    this.updateLabels();

  },
  changeData(dataset){
    // change data
    this.data = dataset;
    // remove all the series, leaving the axes in place
    //this.serie = this.plot.selectAll(".serie").remove();

    // reformat the data
    this.fixData();
    this.sort();
    this.sortLabels();

    // redo scales
    this.createScales();
    // redo axes
    this.updateAxes();

    // draw series and bars
    //this.drawBars();
    this.updateBars();
    // draw labels
    this.updateLabels();

  },
  resize(){
    this.calculateParamaters();
    this.createScales();
   
    // undo transitions for resize
    this.durationVal=0;
    this.updatePlot();
    this.updateAxes();
    this.updateBars();
    this.updateLabels();
   
    // set the labels back
    this.setTransition();

  },
  draw() {
    this.calculateParamaters();
    this.fixData();
    this.sort();
    this.createScales();
    this.createColorScale();
    this.createStack();
    this.createPlot();
    this.drawBars();
    this.drawAxes();

    this.toolInstance = this.tooltip(this);
    this.toolInstance();
    this.drawLabels();
  }
}


export default Chart;



// WEBPACK FOOTER //
// ./app/scripts/FemaleChart.js